module.exports = __webpack_public_path__ + "img/header-weddingRingsBestseller@2x.11fa5f2.webp";